import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-about-us',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './about-us.component.html',
    styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

    constructor(
        private router: Router
    ) {}

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

    goToHome(): void {
        this.router.navigate(['/']);
    }

    goToPartnership(): void {
        this.router.navigate(['/partnership']);
    }

    goToCareer(): void {
        this.router.navigate(['/career']);
    }
}
